import React, { createContext, useEffect, useState } from "react"

import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import FormGroup from 'react-bootstrap/FormGroup'
import { Search, GearFill, BarChartFill, ArrowRight, HouseDoorFill, ImageFill, Grid3x3 } from 'react-bootstrap-icons';
import FA from 'react-fontawesome'
import $ from 'jquery';



function MyNav(prop) {
    useEffect(() => {
        window.FreshworksWidget('identify', 'ticketForm', {
            name: user,
            email: userEmail,
          }, {
            // formId: 1234 Ticket Form ID
          });
    }, [])
    


    const [search, setSearch] = useState(prop.global.params.search);
    const [aVisible, setAVisible] = useState(prop.global.params.annotations);
    const [user,setUser] = useState(window.GlobalVars.userName);
    const userEmail = window.GlobalVars.userEmail;

    function setIcon()
    {
        window.wizzardBar();
        var icon = $('#topicon');
        if( prop.global.pageMenu ) icon.html(prop.global.pageMenu.ficon);
        $('.topbar').find('.user').on('click', userPanelShow )
        function userPanelShow(ev) {
            if ($('.user-panel').length) return;
            var pos = $('.topbar').find('.user')[0].getBoundingClientRect();
            console.log('pos', pos)
            var width = 200;
            var left = pos.left + $('.topbar').find('.user').outerWidth() - width;
            var top = pos.top + $('.topbar').find('.user').outerHeight()
            var userPanel = $('<DIV>').addClass('user-panel').css({ top: top, left: left, width: width });
            userPanel.append($('<DIV>').html('<i class="fa fa-cog"></i> Account Settings').on('click', function () { window.goPage('accountSettings') }));
            if( window.GlobalVars.userRoles.length > 1 ) userPanel.append($('<DIV>').html('<i class="fa fa-user-circle"></i> Change role').on('click', function () { window.goPage('userRole') }));

            userPanel.append($('<DIV>').html('<i class="fa fa-sign-out"></i> Logout').on('click', function () { 
                // if( window.GlobalVars.userAzure ) return window.azureLogout();
                if( window.GlobalVars.azureUser ) return window.azureLogout();
                window.goPage('logout') 
            }));
            $(document.body).append(userPanel);
            $(document.body).on('click', userPanelHide);

            console.log($(this).position())
            ev.preventDefault();
            ev.stopPropagation();
        }
        function userPanelHide(ev)
        {
            $('.user-panel').remove();
            $(document.body).off('click',userPanelHide);
        }
        var name = window.GlobalVars.userName;
        var urole = window.GlobalVars.userCurrentRole;
        if( urole )
        {
            var roleData = []
            roleData.push(urole.companyName);
            var privs = urole.priv.split(',').map( p => window.privs[p] );
            roleData.push( ' - ' + privs.join(', ') );
            // if( urole.projectName ) roleData.push( ' - Project: ' + urole.projectName )
            // if( urole.datasetName ) roleData.push( ' - Dataset: ' + urole.datasetName )
            name += '<div class="user-role">' + roleData.join('') + '</div>';
        }
        $('.user_name').html( name  );
    }
    useEffect( setIcon );
    if( user != window.GlobalVars.userName ) return setUser(window.GlobalVars.userName);
    function searchChange(ev)
    {
        console.log( ev.target.value )
        setSearch( ev.target.value );
    }
    function navClick( ev )
    {
        setTimeout( prop.global.update, 1 );
    }
    function clickAnnotate(ev)
    {
        var checked = ev.target.checked;
        var aGroup = ev.target.parentNode.innerText;
        console.log( 'clickAnnotate', checked, aGroup );
        prop.global.params.annotations[aGroup] = checked;
        setAVisible( prop.global.params.annotations )
        setTimeout( function(){ prop.global.update(true)}, 100 );
        window.saveSession();
    }
    function submit(e)
    {
        e.preventDefault();
        document.location = '#Images';
        prop.global.params.search = search;
        setTimeout( prop.global.update, 1 );
    }
    function SearchField( props )
    {
        if( !page.match(/(Datasets|Images)/)) return ''
        return (
            <Form inline onSubmit={submit}>
            <InputGroup cclassName="mb-3">
            <InputGroup.Prepend>
            <InputGroup.Text id="basic-addon1"><Search/></InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl type="text" name="search" value={props.search} onChange={searchChange}placeholder="Search" className="mr-sm-2"/>
            </InputGroup>
            </Form>
        )
    }
    prop.global.setSearch = setSearch;
    // var annotationGroups = ['Ground Truth', 'Something Else', 'Yet another'];
    var annotationGroups = window.GlobalVars.annotationGroups;
    // console.log( 'aVisible', aVisible )

    var page = '';
    // var Icon = prop.global.pageMenu.icon;
    if( prop.global.pageMenu ) var page = prop.global.pageMenu.name;
    // var Icon = prop.global.pageMenu.icon;
    // <Navbar.Brand href={'#'+page}><Icon className="mr-3"/>{page}</Navbar.Brand>


    var navStyle = window.deeplink.length ? {display:'none'} : {};

    if( page.match(/(Images|Selected)/))
    {
        return (
            <Navbar bg="bg-light" variant="light" className="topbar" style={navStyle}>
            <Navbar.Brand href={'#'+page}><span id="topicon" className="mr-3"></span><div id="pageTitle">{page}</div></Navbar.Brand>
            <Nav className="mr-auto">
            {
                // prop.global.pages.map( p => (
                    //     <Nav.Link key={p} href={'#'+p} active={p===prop.global.page?true:false} onClick={navClick}>{p}</Nav.Link>
                    // ))
                }
                </Nav>
                <Form inline onSubmit={submit} style={{display:page.match(/(Images|Selected)/)?'flex':'none'}}>
                {
                    annotationGroups.map( a => (
                        <Form.Check inline key={'mynav'+a} label={a} type="checkbox" className="groundtruth" checked={aVisible && aVisible[a]} onChange={clickAnnotate}/>
                    ))
                }
                </Form>
                <div className="user" style={{display:user?'block':'none'}}><span className="user_first_letter">{user}</span> <span className="user_name">{user}</span></div>
                </Navbar>
            );
    }
    else
    {
        return (
            <>
            <Navbar bg="bg-light" variant="light" className="topbar" style={navStyle}>
            {/* <Navbar.Brand href={'#'+page}><span id="topicon" className="mr-3"></span><span id="pageTitle">{page}</span></Navbar.Brand> */}
            <Navbar.Brand><div id="pageTitle" >{page}</div></Navbar.Brand>
            <Nav className="mr-auto top-nav">
            {
                // prop.global.pages.map( p => (
                    //     <Nav.Link key={p} href={'#'+p} active={p===prop.global.page?true:false} onClick={navClick}>{p}</Nav.Link>
                    // ))
                }
                </Nav>
                <div className="user" style={{display:user?'block':'none'}}><span className="user_first_letter">{user}</span> <span className="user_name">{user}</span></div>
                </Navbar>
            </>
            );
    }
}

export default MyNav
